import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const fileSettlement = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      totalPage: 0,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data.data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    editReport(state, { payload, index }) {
      Object.assign(state.allData[index], payload);
    },

    removeData(state, { index }) {
      state.totalUsers = state.totalData - 1;
      state.allUsers = state.allData.filter((value) => value.id != index);
    },
  },

  actions: {
    async getDataList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/report/report-settlement/index`;

      const addConfig = { cancelToken: axiosSource.token };
      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == '200') {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
      ctx.commit('setLoading', false);
    },

    async viewSettlement(ctx, { id, date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/report/report-settlement/view`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };

      const doGetOut = () => ctx.dispatch('logout', null, { root: true });
      await axios(config)
        .then((response) => {
          if (response.data.code != 200) {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }

            if (response.data.code == '401') doGetOut();
          } else {
            ctx.commit('setItem', { payload: response.data });
          }
        })
        .catch((err) => {
          if (err.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: err.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (err.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
        });

      ctx.commit('setLoading', false);
    },

    async updateSettlement(ctx, { date, report, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: report.id.toString(),
        channel_type: report.channel_type == 'SFTP' ? '1' : '2',
        file_type: report.file_type,
        email: report.email,
        sftp_ip_address: report.sftp_ip_address,
        sftp_port: report.sftp_port,
        sftp_username: report.sftp_username,
        sftp_password: report.sftp_password,
        sftp_path: report.sftp_path,
        status: report.status_item,
        version: btoa(
          CryptoJS.SHA256(
            report.id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/report/report-settlement/edit`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            ctx.commit('setErrors', response.data.data);

            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          const updatedReport = response.data.data;
          ctx.commit('editReport', {
            payload: updatedReport,
            index,
          });
          return true;
        })
        .catch(() => false)
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async deleteSettlement(ctx, { date, report }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: report.id.toString(),
        version: btoa(
          CryptoJS.SHA256(
            report.id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/report/report-settlement/delete`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          ctx.commit('removeData', {
            report,
          });
          return true;
        })
        .catch(() => {})
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },
  },
};
export default fileSettlement;
